export const logError = (label?: string) => (e: any) => {
    console.error(`[${label ?? 'ui-logger.utils'}]`, e.message);
};
